
import CirclesPurpleIcon from '@src/assets/icons/circles-purple.svg';
import { renderHtmlToReact } from '@src/utils/html';
import React from 'react';
import { Box, Container, Grid } from 'theme-ui';
import { Themed } from '@theme-ui/mdx';

const featureSection = ({ features = [] }) => {
  const vm = {
    features: features.map((feature) => {
      const description = feature?.description?.childMarkdownRemark?.htmlAst;

      return {
        title: feature.title,
        description: description && renderHtmlToReact(description),
        icon: feature?.icon?.file?.url,
      };
    }),
  };

  if (vm.features.length === 0) {
    return <></>;
  }

  return (
    <div className="relative">
      <Container px={4} py={6}>
        <CirclesPurpleIcon className="circle-bottom-left circle-green" />

        <Grid
          py={5}
          gap={['50px', '50px', '20px', '100px']}
          columns={[1, null, 3]}
          sx={{ position: 'relative', zIndex: '1' }}
        >
          {vm.features.map(({ title, icon, description }) => (
            <Box key={title}>
              {icon && <img alt="" src={icon} height="50" width="50" />}

              <Themed.h3 sx={{ lineHeight: '1.2', marginBottom: '20px' }}>
                {title}
              </Themed.h3>
              <Box sx={{ color: 'text700' }}>{description}</Box>
            </Box>
          ))}
        </Grid>
      </Container>
    </div>
  );
};

export default featureSection;
